import type { TranslationMessages } from '../../types';

export const tabs: TranslationMessages = {
  my_profile: 'My Profile',
  checkin_checkout: 'Check-in/Check-out',
  attendance: 'Attendance',
  schedule: 'Schedule',
  shift_switching: 'Shift Switching',
  shift_planning: 'Shift Planning',
  attendance_management: 'Attendance Management',
  daily_checklist: 'Daily Checklist',
  point_earning: 'Point Earning',
  point_store: 'Point Store',
  redemption: 'Redemption',
  ranking: 'Ranking',
  badges: 'Badges',
  rating: 'Rating',
  more: 'More',
  my_profile_desc: 'View your profile information',
  checkin_checkout_desc: 'Check in and out of your shifts',
  attendance_desc: 'View your attendance records and timesheet',
  schedule_desc: 'View your assigned shifts and working hours',
  shift_switching_desc: 'Request and manage your shift exchanges',
  shift_planning_desc: 'Shift scheduling (Manager/Admin only)',
  daily_checklist_desc: 'Your daily task checklist and completion tracking',
  point_earning_desc: 'Complete tasks to earn points and rewards',
  point_store_desc: 'Redeem your earned points for rewards',
  redemption_desc: 'Manage your point redemptions and rewards',
  ranking_desc: 'View your performance ranking among staff',
  badges_desc: 'View your achievement badges and rewards',
  rating_desc: 'View your customer and manager ratings',
  policies: 'Policies',
  policies_desc: 'View company policies',
  leave_requests: 'Leave Requests',
  leave_requests_desc: 'Manage and request days off',
};
